import { SUPPORTED_LANGUAGES } from '../config';

export const isLanguageSupported = (lang: string | null | undefined) => {
  if (!lang) return false;
  return lang in SUPPORTED_LANGUAGES;
};
